import * as types from '../actions/types';

const initialState = {
    msgType: null,
    message: null,
    statusCode: null,
};

const addFlashMessageReducer = (state, action) => ({
    msgType: action.msgType,
    message: action.message || null,
    statusCode: action.statusCode || null,
});

const clearFlashMessageReducer = () => ({
    ...initialState,
});

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case types.REINITIALIZE_STORE_STATE:
            return {...initialState};
        case types.ADD_FLASH_MESSAGE:
            return addFlashMessageReducer(state, action);
        case types.CLEAR_FLASH_MESSAGE:
            return clearFlashMessageReducer(state, action);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/js/reducers/flash-messages.js